import {ClienteViewModel} from './clienteViewModel';
import {RolViewModel} from './rolViewModel';

export class UsuarioViewModel {
    id: string;
    userName: string;
    nombre: string;
    apellido: string;
    isActive: boolean;
    recibeComprobantes: boolean;
    clientes: Array<ClienteViewModel>;
    roles: Array<RolViewModel> = new Array();
}

export class NuevoUsuarioViewModel extends UsuarioViewModel{
    password: string;
    repitePassword: string;
}

export class NuevoPasswordViewModel{
    usuarioId: string;
    token: string;
    password: string;
    repitePassword: string;
}


// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/models/viewmodels/UsuarioViewmodel.ts